import { render, staticRenderFns } from "./formAdditionalData.vue?vue&type=template&id=0295219c&scoped=true"
import script from "./formAdditionalData.vue?vue&type=script&lang=js"
export * from "./formAdditionalData.vue?vue&type=script&lang=js"
import style0 from "./formAdditionalData.vue?vue&type=style&index=0&id=0295219c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0295219c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0295219c')) {
      api.createRecord('0295219c', component.options)
    } else {
      api.reload('0295219c', component.options)
    }
    module.hot.accept("./formAdditionalData.vue?vue&type=template&id=0295219c&scoped=true", function () {
      api.rerender('0295219c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/vehicle/components/form/steps/formAdditionalData.vue"
export default component.exports